// QM §5.3 (Queue Settings), §5.4 (Queues), §5.5 (Queues Management).
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export const QUEUE_PERMISSIONS = {
  'Queue Settings': {
    create: false,
    read: false,
    update: false,
    delete: false,
  },
  Queues: { create: 'no', read: false, update: false, delete: 'no' },
  'Queues Management': {
    create: 'no',
    read: false,
    update: false,
    delete: 'no',
  },
};
// d99d Permissions that only exist for accounts the matching feature is enabled on. They are
// hidden from the role editor everywhere else - see PermissionByGroup.vue.
export const FEATURE_GATED_PERMISSIONS = {
  'Concurrent Users': FEATURE_FLAGS.CONCURRENT_USERS,
};

export const GENERAL_PERMISSIONS = {
  ...QUEUE_PERMISSIONS,
  Contacts: { create: false, read: false, update: false, delete: false },
  Reports: { create: 'no', read: false, update: 'no', delete: 'no' },
  Analytics: { create: false, read: false, update: false, delete: false },
  Campaigns: { create: false, read: false, update: false, delete: false },
  'WhatsApp Templates': {
    create: false,
    read: false,
    update: 'no',
    delete: false,
  },
  Studio: {
    create: 'no',
    read: false,
    update: 'no',
    delete: 'no',
  },
  Docal: { create: false, read: false, update: false, delete: false },
  'Workflow Builder': {
    create: 'no',
    read: false,
    update: 'no',
    delete: 'no',
  },
  ChatGPT: { create: false, read: false, update: false, delete: false },
  Click2Call: { create: false, read: false, update: false, delete: false },
  IntegrationDocal: { create: false, read: false, update: false, delete: false },
  Forms: { create: false, read: false, update: false, delete: false },
  'Forms Responses': {
    create: 'no',
    read: false,
    update: 'no',
    delete: 'no',
  },
  IntegrationForms: { create: false, read: false, update: false, delete: false },
  'Mobile App': { create: false, read: false, update: false, delete: false },
  Webhooks: { create: false, read: false, update: false, delete: false },
  'External Dashboard': {
    create: false,
    read: false,
    update: false,
    delete: false,
  },
  'Direct Chat': {
    create: 'no',
    read: false,
    update: 'no',
    delete: 'no',
  },
  'Account settings': {
    create: 'no',
    read: false,
    update: false,
    delete: 'no',
  },
  'Concurrent Users': {
    create: 'no',
    read: false,
    update: false,
    delete: 'no',
  },
  Agents: { create: false, read: false, update: false, delete: false },
  Roles: { create: false, read: false, update: false, delete: false },
  'Disconnect Agents': {
    create: 'no',
    read: 'no',
    update: false,
    delete: 'no',
  },
  Teams: { create: false, read: false, update: false, delete: false },
  Inbox: { create: false, read: false, update: false, delete: false },
  Labels: { create: false, read: false, update: false, delete: false },
  'Custom attributes': {
    create: false,
    read: false,
    update: false,
    delete: false,
  },
  Automations: {
    create: false,
    read: false,
    update: false,
    delete: false,
  },
  Macros: { create: false, read: false, update: false, delete: false },
  'Canned Responses': {
    create: false,
    read: false,
    update: false,
    delete: false,
  },
  'Audit Logs': {
    create: 'no',
    read: false,
    update: 'no',
    delete: 'no',
  },
  Sla: {
    create: false,
    read: false,
    update: false,
    delete: false,
  },
  'CSAT Survey': {
    create: false,
    read: false,
    update: false,
    delete: false,
  },
  'Export Wizard': {
    create: false,
    read: 'no',
    update: 'no',
    delete: 'no',
  },
  'Import Wizard': {
    create: false,
    read: 'no',
    update: 'no',
    delete: 'no',
  },
  'Help and Support': {
    create: 'no',
    read: false,
    update: 'no',
    delete: 'no',
  },
  'File Storage': {
    create: 'no',
    read: false,
    update: 'no',
    delete: false,
  },
  Changelog: { create: 'no', read: false, update: 'no', delete: 'no' },
  'Api Docs': {
    create: 'no',
    read: false,
    update: 'no',
    delete: 'no',
  },
  'Profile page': {
    create: 'no',
    read: false,
    update: false,
    delete: 'no',
  },
  'Auto Presence': {
    create: 'no',
    read: false,
    update: false,
    delete: 'no',
  },
  Lists: {
    create: false,
    read: false,
    update: false,
    delete: false,
  },
};

export const INBOX_PERMISSIONS = [
  // the order of this items matters we are using it in EditRole.vue
  'Inbox read (Collaborator alias)',
  'Inbox read (Team)',
  'Inbox read unassigned conversations',
  'Inbox read all conversations',
  'Inbox new message',
  'Inbox reply',
  'Inbox private notes',
  'Inbox attach files',
  'Inbox see conversations history',
  'Inbox delay message',
  'Inbox can assign',
  'Inbox can be assigned',
  'Inbox resolve',
  'Inbox reopen',
  'Inbox manual/bot switch',
  'Inbox move to pending',
  'Inbox delete message',
  'Inbox ai assistance',
  'Inbox priority of conversations',
  'Inbox assign labels',
  'Inbox assign to group',
  'Inbox send Transcript',
  'Inbox canned responses',
  'Inbox export conversations',
];

export const GENERAL_PERMISSIONS_GROUPS = {
  core_date_and_communication: {
    ...QUEUE_PERMISSIONS,
    Contacts: { create: false, read: false, update: false, delete: false },
    Campaigns: { create: false, read: false, update: false, delete: false },
    'WhatsApp Templates': {
      create: false,
      read: false,
      update: 'no',
      delete: false,
    },
    Studio: {
      create: 'no',
      read: false,
      update: 'no',
      delete: 'no',
    },
    'Workflow Builder': {
      create: 'no',
      read: false,
      update: 'no',
      delete: 'no',
    },
  },
  report_and_analytics: {
    Reports: { create: 'no', read: false, update: 'no', delete: 'no' },
    Sla: {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    'CSAT Survey': {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    Changelog: { create: 'no', read: false, update: 'no', delete: 'no' },
    Analytics: { create: false, read: false, update: false, delete: false },
  },
  intergrations: {
    ChatGPT: { create: false, read: false, update: false, delete: false },
    Click2Call: { create: false, read: false, update: false, delete: false },
    IntegrationDocal: {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    'Mobile App': { create: false, read: false, update: false, delete: false },
    Webhooks: { create: false, read: false, update: false, delete: false },
    Docal: { create: false, read: false, update: false, delete: false },
    'External Dashboard': {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    'Direct Chat': {
      create: 'no',
      read: false,
      update: 'no',
      delete: 'no',
    },
    'Api Docs': {
      create: 'no',
      read: false,
      update: 'no',
      delete: 'no',
    },
    Forms: { create: false, read: false, update: false, delete: false },
    'Forms Responses': {
      create: 'no',
      read: false,
      update: 'no',
      delete: 'no',
    },
    IntegrationForms: {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
  },
  setting_user_and_access: {
    'Account settings': {
      create: 'no',
      read: false,
      update: false,
      delete: 'no',
    },
    'Concurrent Users': {
      create: 'no',
      read: false,
      update: false,
      delete: 'no',
    },
    Agents: { create: false, read: false, update: false, delete: false },
    Roles: { create: false, read: false, update: false, delete: false },
    'Disconnect Agents': {
      create: 'no',
      read: 'no',
      update: false,
      delete: 'no',
    },
    'Help and Support': {
      create: 'no',
      read: false,
      update: 'no',
      delete: 'no',
    },
    Inbox: { create: false, read: false, update: false, delete: false },
    Teams: { create: false, read: false, update: false, delete: false },
  },
  setting_configuration: {
    Labels: { create: false, read: false, update: false, delete: false },
    'Custom attributes': {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    Automations: {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    Macros: { create: false, read: false, update: false, delete: false },
    'Canned Responses': {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    'File Storage': {
      create: 'no',
      read: false,
      update: 'no',
      delete: false,
    },
    'Auto Presence': {
      create: 'no',
      read: false,
      update: false,
      delete: 'no',
    },
    'Profile page': {
      create: 'no',
      read: false,
      update: false,
      delete: 'no',
    },
    'Export Wizard': {
      create: false,
      read: 'no',
      update: 'no',
      delete: 'no',
    },
    'Import Wizard': {
      create: false,
      read: 'no',
      update: 'no',
      delete: 'no',
    },
    'Audit Logs': {
      create: 'no',
      read: false,
      update: 'no',
      delete: 'no',
    },
  },
};

export const PERMISSION_DEPENDENCIES = {
  Campaigns: { read: ['create', 'update', 'delete'] },
};
